import { render, staticRenderFns } from "./PartnerModification.vue?vue&type=template&id=256a508e&"
import script from "./PartnerModification.vue?vue&type=script&lang=ts&"
export * from "./PartnerModification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports